export default [
  {
    id: '10889195-c51b-4e6a-b9ba-f5dac47a4707',
    path: 'desensitization',
    name: 'desensitization',
    meta: { title: '数据安全保护' },
    children: [
      {
        id: '5784c3c4-fa69-4b45-b230-0e2482b7a15f',
        path: 'desensitization-rules',
        name: 'desensitization-rules',
        component: () => {
          return import('../views/desensitizationManage/desensitizationRules')
        },
        meta: {
          title: '数据脱敏规则',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 4,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '9566e618-9930-408a-a841-31272448363a',
        path: 'applications',
        name: 'applications',
        component: () => {
          return import('../views/desensitizationManage/applications')
        },
        meta: {
          title: '数据脱敏应用',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 4,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: 'f40f51f4-2ed9-4058-8789-2dc1d6207b1d',
        path: 'data-permissions',
        name: 'data-permissions',
        component: () => {
          return import('../views/desensitizationManage/dataPermissions')
        },
        meta: {
          title: '数据权限管理',
          keepAlive: false,
          operations: {
            application: {
              id: 0,
              name: 'application',
              desc: '权限申请',
              access: true,
            },
            reclaim: {
              id: 1,
              name: 'reclaim',
              desc: '权限回收',
              access: true,
            },
          },
        },
      },
      {
        id: '755940c6-7e97-4f19-a4d6-15bd7f090fc6',
        path: 'auth-config',
        name: 'auth-config',
        component: () => {
          return import('../views/desensitizationManage/components/authConfig')
        },
        meta: {
          title: '权限配置',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/desensitization/data-permissions',
        },
      },
      {
        id: '37522479-7adc-4c10-8952-c3500f1d0e4d',
        path: 'data-permissions-detail',
        name: 'data-permissions-detail',
        component: () => {
          return import('../views/desensitizationManage/components/dataPermissionsDetail')
        },
        meta: {
          title: '权限详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/desensitization/data-permissions',
          operations: {
            application: {
              id: 0,
              name: 'application',
              desc: '添加权限申请',
              access: true,
            },
            reclaim: {
              id: 1,
              name: 'reclaim',
              desc: '权限回收',
              access: true,
            },
          },
        },
      },
      {
        id: '31b0db0c-e755-4304-8cf0-5b87339adfa1',
        path: 'permission-change-records',
        name: 'permission-change-records',
        component: () => {
          return import('../views/desensitizationManage/components/permissionChangeRecords')
        },
        meta: {
          title: '权限变更记录',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/desensitization/permission-change-records',
          operations: {},
        },
      },
    ],
  },
]
